// Dependencies
require("webstrap/type");
require("webstrap/responsive-embed");
require("grid");
require("section/generic");


/*****************
 ** WEBPACK FOOTER
 ** ./LeLab.LogAlto.Web/src/modules/block/videos/index.js
 ** module id = 191
 ** module chunks = 0 1
 **/